module.exports = new __parcel__URL__("faq_content_ja.2e55be49.webp").toString();